import { openModalWithCallback } from '../../actions/open-modal';
import * as MODAL_TYPE from '../../constants/modal-types';
import { getMember } from '../members/selectors';
import { setMember } from '../members/actions';
import { sendActionToFrames } from '../../services/frames-messages';
import Wix from '../../services/wix-sdk-polyfill';
import { getBaseUrl } from '../../services/getBaseUrl';

export const openManageBadgesModal = (memberUid) => (dispatch, getState, { request }) => {
  const member = getMember(getState(), memberUid);
  const modalData = { memberName: member.name, memberBadgesIds: member.badges || [] };
  const onConfirm = (badgeIds) =>
    request.post(`/_api/members/${memberUid}/badges`, { badgeIds }).then(() => {
      const updateMemberAction = setMember({ ...member, badges: badgeIds });
      dispatch(updateMemberAction);
      sendActionToFrames(updateMemberAction);
    });

  dispatch(openModalWithCallback(MODAL_TYPE.MANAGE_BADGES, onConfirm, modalData));
};

export const openBadgesDashboard = (origin) => (_, __, { badgesBiLogger }) => {
  badgesBiLogger.manageBadgesClick({
    origin,
  });
  Wix.Settings.getAppAPI(
    (api) => api.openBadgesBm(origin).then(() => Wix.Settings.refreshApp()),
    () => {},
  );
};

export const openBadgesInNewTab = (origin) => (_, __, { badgesBiLogger }) => {
  badgesBiLogger.manageBadgesClick({
    origin,
  });
  const metasiteId = Wix.Utils.getInstanceValue('metaSiteId');
  const styleParams = Wix.Styles.getStyleParams();
  const isEditorX = styleParams && styleParams.booleans && styleParams.booleans.responsive;
  const url = `${getBaseUrl(isEditorX)}/dashboard/${metasiteId}/badge-definitions`;
  window.open(url, '_blank');
};
